import { render } from "./AddMerchant.vue?vue&type=template&id=e4661ef6&scoped=true"
import script from "./AddMerchant.vue?vue&type=script&lang=js"
export * from "./AddMerchant.vue?vue&type=script&lang=js"

import "./AddMerchant.vue?vue&type=style&index=0&id=e4661ef6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4661ef6"]])

export default __exports__